var _defs, _circle, _line, _line2, _line3, _line4, _line5, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew309({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.36,
    cy: 8.53,
    r: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.36,
    y1: 8.53,
    x2: 6.36,
    y2: 8.53
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.61,
    y1: 9.56,
    x2: 6.11,
    y2: 9.56
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.61,
    y1: 7.51,
    x2: 6.11,
    y2: 7.51
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.11,
    y1: 10.58,
    x2: 5.61,
    y2: 10.58
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.11,
    y1: 6.48,
    x2: 5.61,
    y2: 6.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.41,10.14V6.92H8.58A1.25,1.25,0,0,1,9.12,7a.76.76,0,0,1,.29.3,1.07,1.07,0,0,1,.11.49.93.93,0,0,1-.19.59.89.89,0,0,1-.56.29A.92.92,0,0,1,9,8.86a2.42,2.42,0,0,1,.27.41l.46.87H9.29l-.35-.67a3.53,3.53,0,0,0-.31-.53.54.54,0,0,0-.2-.18.62.62,0,0,0-.27,0H7.75v1.43Zm.34-1.8h.76a.92.92,0,0,0,.37-.06.49.49,0,0,0,.2-.18.61.61,0,0,0,.08-.3A.49.49,0,0,0,9,7.42a.53.53,0,0,0-.42-.14H7.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.48,10.14,9.77,6.92h.36L10.53,9c.05.22.08.44.12.66l.11-.59.51-2.18h.42l.38,1.63a10.55,10.55,0,0,1,.2,1.14L12.4,9l.42-2.07h.35l-.72,3.22h-.34l-.56-2.45-.08-.38c0,.14-.05.27-.08.38l-.56,2.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.39,8.57a1.93,1.93,0,0,1,.36-1.26,1.14,1.14,0,0,1,.91-.45,1.1,1.1,0,0,1,.63.2,1.28,1.28,0,0,1,.46.58,2.21,2.21,0,0,1,.17.89,1.93,1.93,0,0,1-.33,1.17,1.11,1.11,0,0,1-.94.5,1.1,1.1,0,0,1-.94-.51A1.94,1.94,0,0,1,13.39,8.57Zm.36,0A1.44,1.44,0,0,0,14,9.5a.8.8,0,0,0,1.29,0,1.59,1.59,0,0,0,.26-1,2,2,0,0,0-.14-.74.89.89,0,0,0-.31-.4.76.76,0,0,0-.45-.15.79.79,0,0,0-.65.33A1.66,1.66,0,0,0,13.75,8.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew309);
export default __webpack_public_path__ + "static/media/Symbolpack_New_309.6030ef865d494c33aed1a31ba3e74603.svg";
export { ForwardRef as ReactComponent };